const getURL = env => {
  const url =
    process.env.APP_NAME === 'TRIPLEMARS'
      ? `api-${env}.triplemars.com`
      : `api-${env}.triplemarsb2b.com`;
  return url;
};

let BASE_URL = '';
const env = process.env.REACT_APP_ENV;

switch (true) {
  case env === 'prod':
    BASE_URL = getURL('prod');
    break;

  case env === 'test':
    BASE_URL = getURL('test');
    break;

  case env === 'local':
    BASE_URL = getURL('local');
    break;

  default:
    BASE_URL = getURL('dev');
}

const config = {
  API_URL5008: `${window.location.protocol}//${BASE_URL}`,
  API_URL5007: `${window.location.protocol}//${BASE_URL}/api`,
  API_URL: `${window.location.protocol}//${process.env.REACT_APP_API_URL}`,
  API_URL3005: 'https://localhost:5001',
};

export default config;
